<template>
    <div class="ionic-container rounded" align="center" id="parent_container">
        <div :id="constructionSite" style="height: 100%;"></div>
    </div>
</template>

<script >

import '@/assets/next-ui-vue/js/next.js';
import '@/assets/next-ui-vue/css/next_light.css';



export default {
    name: 'Topology',
    props:{
        constructionTitle: String,
        titleColor: String,
        titleSize: String,
        constructionTheme: String, 
        constructionID: String,
        constructionSite: String,
        icons: Object,
        // This is the event to be triggered in the parent component.
        outterEventName: String

    },
    data(){
        return {
            nx: null,
            topologyApp: null,
            topology: null,
            topologyConfig: {
                // Unique Identifier.
                id: null,
                // Size
                //width: 10,
                //height: 200,
                // Nodes Configuration.
                nodeConfig: { label: "model.name", iconType: "model.iconType", id: "model.id", color: "model.iconColor", type: "model.type", data: "model.data"},
                // Links Configuration.
                linkConfig: { linkType: "curve", 
                              width: 3 ,
                              id: "model.id", 
                              color: "model.linkColor",
                              //label: "model.labeling"
                              //style: { 'stroke-dasharray' : '2,10' }
                            },
                nodeSetConfig: { label: "model.name",
                              iconType: "model.iconType",
                              id: "model.id", 
                              color: "model.iconColor",
                              //label: "model.labeling"
                              //style: { 'stroke-dasharray' : '2,10' }
                            },
                // If true: show icon, otherwise show a dot.
                showIcon: true,
                adaptive: true,
                smartLabel: true,
                // Automatically compute the position of nodes.
                dataProcessor: "force",
                // Set theme: blue, yellow
                theme: null, 
                //nodeInstanceClass: 'Extended-Scene'
            },
            methodsSettings:{},
        }
    },
    components: {},
    methods: {
        outterSignal(elementData){
            // Emitting event to parent.
            this.$emit(this.outterEventName, elementData)
        },
        createTopology(topologyData){
            // Celar the additional creations of NeXT.
            this.clearAdditionals()
            // Construction Site
            var cs = document.getElementById(this.constructionSite)
            // Reset the construction site
            cs.innerHTML = ""
            // Set the theme.
            this.topologyConfig.theme = this.constructionTheme
            // Get the contruction site.
            this.topologyConfig.id = this.constructionID
            // Create the app.
            this.topologyApp = new nx.ui.Application();
            // Events
            const vueThis = this
            nx.define('ElementOnClick', nx.graphic.Topology.DefaultScene, {
                methods: {
                    clickNode: function(sender, node){
                        vueThis.outterSignal({ id: node.id(), type: "node", data: node })
                    },
                    clickLink: function(sender, link){
                        vueThis.outterSignal({ id: link.id(), type: "link" })
                    }
                }
            });

            // Create the topology
            this.topology = new nx.graphic.Topology(this.topologyConfig);

            // Icons

            for (const [key, value] of Object.entries(this.icons)) {
                this.topology.registerIcon(key, value, 70, 70);
            }
            
            // Load topology data from the source.
	        this.topology.data(topologyData);

            // Register  an scene
            this.topology.registerScene('element-on-click', 'ElementOnClick');
            this.topology.activateScene('element-on-click');

            
            // Bind the topology object to the topology app.
	        this.topology.attach(this.topologyApp);

            // Build
            this.topologyApp.container();
            
            // Move the content to the target div.
            cs.appendChild(document.getElementById(this.constructionID))

            //var ms = document.getElementsByClassName('n-topology-setting-panel')[0]
            //ms.remove()

        },
        clearAdditionals(){
            var mc = document.getElementsByClassName('nx n-popupContainer')[0]
            mc.innerHTML = ""
        }
    },
    mounted: function(){}
        
    }
</script>

<style scoped>

    /* @import '/assets/next-ui-vue/css/next.css'; */
    
    .ionic-container{
        border: solid 5px rgb(0, 54, 73);
        overflow: hidden;
        height: 580px;
    }

    .ionic-title{
        font-weight: 300;
    }

    .ionic-title-sm{
        font-size: 12px;
    }
    .ionic-title-md{
        font-size: 24px;
    }
    .ionic-title-lg{
        font-size: 48px;
    }

    .ionic-white{
        color: White;
    }
    .ionic-black{
        color: Black;
    }

</style>